import BaseComponent from "../../../Flex/Delegates/CreateMany/CreateManyDelegates";

export default class CreateManyDelegates extends BaseComponent
{
}